import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import UIObjectCourse from './object-course-list'
import UIObjectCourseDetails from './object-course-details'
import UIObjectCourseStudents from './object-course-students'

export default class ObjectCourse extends Component {
    render() {
        return (
            <Switch>
                <Route path='/culturalcreativeworks/course' component={UIObjectCourse} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/culturalcreativeworks/course/details' component={UIObjectCourseDetails} />
                <Route path='/culturalcreativeworks/course/students' component={UIObjectCourseStudents} />
                <Redirect to='/culturalcreativeworks/course' />
            </Switch>
        )
    }
}